import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { debounce } from 'lodash';
import { environment } from 'src/environments/environment';
import { MessageService } from 'primeng/api';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrderService } from 'src/app/services/order.service';
import { StorageService } from 'src/app/services/storage.service';

declare var $: any;

  export function noScriptTagValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value && typeof control.value === 'string') {
        const scriptPattern = /<script[\s\S]*?>[\s\S]*?<\/script>/gi;
        if (scriptPattern.test(control.value)) {
          return { scriptDetected: true };
        }
      }
      return null;
    };
  }

@Component({
    selector: 'app-template-edit',
    templateUrl: './template-edit.component.html',
    styleUrls: ['./template-edit.component.scss'],
    standalone: false
})
export class TemplateEditComponent implements OnInit {
  @ViewChild('myIframe') myIframe: ElementRef<HTMLIFrameElement>;
  templateDataForm: FormGroup;
  submited: boolean = false;
  emailPattern = '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}';
  phonePattern = '[0-9]{10}';
  public filledCounter = 0;
  public considerationPrice = 0;
  public eventCount = 0;
  submitted: boolean = false;
  fields: any[] = [];
  pdfSource: SafeResourceUrl | null = null;
  isLoadingPdf: boolean = false;
  //---------------Templete Code ---------------------------------------------------//
  documentSchema: any;
  selectedTemplate: any;
  @Output() filledEvent: EventEmitter<any> = new EventEmitter<number>();
  @Output() customEvent: EventEmitter<any> = new EventEmitter<number>();
  @Output() elementCompleted: EventEmitter<any> = new EventEmitter<string>();
  //---------------End ---------------------------------------------------//

  htmlData: any;
  sanitizedHtmlContent: string = '';
  @Input() editTemplateData: any;
  @Output() editTemplateChange: EventEmitter<any> = new EventEmitter<[]>();
  sanitizedTemplateUrl: any;
  replaceHtml: string;
  highlightedValue: string;
  baseEndPoint: string;
  templateData: any;
  templateDataValues: any =[];
  templateName:string ='';

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private sanitizer: DomSanitizer,
    private messageService: MessageService,
    private modalService: NgbModal,
    private orderService: OrderService,
    private storageService: StorageService,
    private cdr: ChangeDetectorRef,
  ) {
    this.templateDataForm = this.formBuilder.group({
      fieldDataForms: this.formBuilder.array([])
    });
    this.onInputChange = debounce(this.onInputChange, 1000);
    this.baseEndPoint = environment.apiURL;
  }

  ngOnInit() {
    this.storageService.setfiletype('editPdf');

    if (this.editTemplateData.form === undefined) {
      this.templateName = this.editTemplateData.name;
      this.fields = this.editTemplateData.fileds;
      this.sanitizedHtmlContent = this.editTemplateData.template_html;
      this.setTemplateFields();
    } else {
      this.templateName = this.editTemplateData.name;
      this.fields = this.editTemplateData.form.fieldDataForms;
      this.sanitizedHtmlContent = this.editTemplateData.html;
      this.setTemplateFields();
    }
    this.buildPreviewHtml();
  }
  //-------------------------Creating Html Url


  //---------------Templete Code ---------------------------------------------------//
  loadPDF(data: any) {
    this.orderService.getEditTemplatePDFDocument(data).subscribe((resp) => {
      const byteArray = new Uint8Array(
        atob(resp.content.document_url)
          .split('')
          .map((char) => char.charCodeAt(0))
      );
      const file = new Blob([byteArray], { type: 'application/pdf' });
      this.pdfSource = URL.createObjectURL(file);
      this.isLoadingPdf = false;
      this.cdr.detectChanges();
    });
  }

  onInputChange(event, value) {
   

    if (value.html_tag === 'date') {
      const dateParts = value.value_attribute.split('-');
      if (dateParts.length === 3) {
        const [year, month, day] = dateParts;
        value.value_attribute = `${day}-${month}-${year}`;
      }
    } 

    const updated = this.updatePreviewInPlace(value.id_attribute, value.value_attribute);

    if (updated) {
      this.scrollToField(value.id_attribute, 0);
      this.fieldScrollIndex[value.id_attribute] = 1;
    } else {
      this.buildPreviewHtml();
      this.pendingScrollFieldId = value.id_attribute;
      const iframeElement = this.myIframe.nativeElement;
      iframeElement.onload = () => {
        iframeElement.onload = null;
        if (this.pendingScrollFieldId === null) {
          return;
        }
        const targetId = this.pendingScrollFieldId;
        this.pendingScrollFieldId = null;
        this.scrollToField(targetId, 0);
        this.fieldScrollIndex[targetId] = 1;
      };
      iframeElement.srcdoc = this.htmlData;
    }
  }

  private updatePreviewInPlace(id: string, value: any): boolean {
    if (!this.myIframe) {
      return false;
    }
    const win = this.myIframe.nativeElement.contentWindow;
    if (!win || !win.document) {
      return false;
    }
    const spans = win.document.querySelectorAll(`.field-${id}`);
    if (!spans.length) {
      return false; // not rendered yet
    }
    const hasValue = value !== null && value !== undefined && String(value).trim() !== '';
    spans.forEach((el) => {
      const span = el as HTMLElement;
      span.textContent = hasValue ? String(value) : `$${id}`;
      span.style.backgroundColor = hasValue ? 'yellow' : '';
    });
    return true;
  }

  private fieldOccurrenceCount: { [id: string]: number } = {};
  private fieldScrollIndex: { [id: string]: number } = {};
  private scrollTimerId: number | null = null;
  private pendingScrollFieldId: string | null = null;
  private buildPreviewHtml() {
    this.replaceHtml = this.sanitizedHtmlContent;
    this.fieldOccurrenceCount = {};
    this.templateDataForm.value.fieldDataForms.forEach(item => {
      this.replaceHtml = this.replaceHtml.replace(
        /\$([\w]+)/g,
        (key) => {
          return this.getDynamicValue(item.value_attribute, item.id_attribute, key);
        }
      );
    });
    this.htmlData = this.replaceHtml;
  }

  getDynamicValue(value: string, id: string, key: string): string {
    if (key === '$' + id) {
      const occurrence = this.fieldOccurrenceCount[id] ?? 0;
      this.fieldOccurrenceCount[id] = occurrence + 1;
      const hasValue = value !== null && value !== undefined && String(value).trim() !== '';
      const content = hasValue ? value : key; // keep placeholder text when empty
      const bg = hasValue ? 'background-color: yellow;' : '';
      this.highlightedValue =
        `<span id="field-${id}-${occurrence}" class="highlighted-value field-${id}" ` +
        `style="${bg}">${content}</span>`;
      return this.highlightedValue;
    }
    return key;
  }

  scrollToField(idAttribute: string, occurrenceIndex?: number, attempt: number = 0) {
    if (!idAttribute || !this.myIframe) {
      return;
    }
    const iframeElement = this.myIframe.nativeElement;
    const iframeWindow = iframeElement.contentWindow;
    if (!iframeWindow || !iframeWindow.document) {
      return;
    }

    const occurrences = iframeWindow.document.querySelectorAll(`.field-${idAttribute}`);
    if (!occurrences.length) {
      if (attempt < 5) {
        setTimeout(() => this.scrollToField(idAttribute, occurrenceIndex, attempt + 1), 100);
      }
      return;
    }
    let index: number;
    if (occurrenceIndex !== undefined) {
      index = occurrenceIndex;
    } else {
      index = this.fieldScrollIndex[idAttribute] ?? 0;
    }
    index = ((index % occurrences.length) + occurrences.length) % occurrences.length;

    const target = occurrences[index] as HTMLElement;
    const scroller = (iframeWindow.document.scrollingElement ||
      iframeWindow.document.documentElement) as HTMLElement;
    const currentScroll = iframeWindow.scrollY || iframeWindow.pageYOffset || scroller.scrollTop || 0;
    const rect = target.getBoundingClientRect();
    const absoluteTop = rect.top + currentScroll;
    const topOffset = 64;
    const desiredTop = absoluteTop - topOffset;

    const maxTop = Math.max(0, scroller.scrollHeight - iframeWindow.innerHeight);
    const top = Math.max(0, Math.min(desiredTop, maxTop));

    this.animateIframeScroll(iframeWindow, top, 900);
    this.fieldScrollIndex[idAttribute] = index + 1;
  }

  private animateIframeScroll(win: Window, to: number, duration = 900) {
    if (this.scrollTimerId !== null) {
      clearInterval(this.scrollTimerId);
      this.scrollTimerId = null;
    }

    const start = win.scrollY || win.pageYOffset || 0;
    const change = to - start;
    if (Math.abs(change) < 1) {
      win.scrollTo(0, to);
      return;
    }
    const startTime = performance.now();

    const ease = (t: number) =>
      t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

    this.scrollTimerId = window.setInterval(() => {
      const progress = Math.min((performance.now() - startTime) / duration, 1);
      const current = start + change * ease(progress);
      win.scrollTo(0, current);

      if (progress >= 1) {
        if (this.scrollTimerId !== null) {
          clearInterval(this.scrollTimerId);
          this.scrollTimerId = null;
        }
      }
    }, 16);
  }

  onFieldFocus(field: any) {
    if (!this.htmlData) {
      this.buildPreviewHtml();
    }
    const value = field?.value_attribute;
    const hasValue = value !== null && value !== undefined && String(value).trim() !== '';
  
    if (this.pendingScrollFieldId !== null && this.pendingScrollFieldId !== field?.id_attribute) {
      this.pendingScrollFieldId = null;
    }
    
    if (!hasValue) {
      if (this.scrollTimerId !== null) {
        clearInterval(this.scrollTimerId);
        this.scrollTimerId = null;
      }
      return;
    }
    this.scrollToField(field?.id_attribute);
  }
















  //-------------------- Adding Form Array to display the template form Details --------------------------//

  createFieldControl() {
    return this.formBuilder.group({
      name_attribute: new FormControl('', [Validators.required]),
      value_attribute: new FormControl('', [Validators.required, noScriptTagValidator()]),
      html_tag: new FormControl('', [Validators.required]),
      label_attribute: new FormControl('', [Validators.required]),
      id_attribute: new FormControl(''),
      validators: new FormControl({}, [Validators.required]),
      
    });
  }

  fieldDataForms(): FormArray {
    return this.templateDataForm.get('fieldDataForms') as FormArray;
  }

  addNewField() {
    this.fieldDataForms().push(this.createFieldControl())
  }

  removeFields(index: number) {
    this.fieldDataForms().removeAt(index);
  }

  //----- set the field data into the forms -----------------------//

  setTemplateFields() {
    this.fields.forEach((field) => {
      this.addNewField();
      const lastIndex = this.fieldDataForms().length - 1;
      const lastFormGroup = this.fieldDataForms().at(lastIndex);
      this.fieldDataForms().at(lastIndex).patchValue(field);
      // lastFormGroup.patchValue({ value_attribute: '' });


    });
  }


 
  onKeyPress(event: any, patternRequired: string) {
    if(patternRequired){
      const pattern = new RegExp(patternRequired);
      const inputChar = String.fromCharCode(event.charCode);
    
      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    }
  }

 onPaste(event: ClipboardEvent, patternRequired?: string) {
  const clipboardData = event.clipboardData;
  const pastedText = clipboardData?.getData('text') || '';
  
  // First check for script tags (security priority)
  const scriptPattern = /<script[\s\S]*?>[\s\S]*?<\/script>/gi;
  if (scriptPattern.test(pastedText)) {
    event.preventDefault();
    this.messageService.add({
      severity: 'error',
      summary: 'Security Alert',
      detail: 'Malicious content detected. Script tags are not allowed.',
      life: 3000
    });
    return;
  }
    if (patternRequired) {
      const pattern = new RegExp(patternRequired);
      if (!pattern.test(pastedText)) {
        event.preventDefault();
        this.messageService.add({
        severity: 'warn',
        summary: 'Invalid Input',
        detail: 'The pasted content does not match the required pattern.',
        life: 3000
      });
      }
    }
  }  


  gotoDashboard() {
    this.router.navigate(['doqfy/dashboard']);
  }
  //----------------------- Send Data to parent Component -------------------------------//
  sendTemplateDetails() {
    var editTemplateFieldsData: any = [];
    this.templateDataForm.value.fieldDataForms.forEach(field => {
     if(field.value_attribute === null){
      field.value_attribute = '  ';
     }
      const data = { key: field.id_attribute, value: field.value_attribute };
      editTemplateFieldsData.push(data)
    })
    editTemplateFieldsData.page = 'estamp';
    editTemplateFieldsData.form = this.templateDataForm.value;
    this.buildPreviewHtml();
    editTemplateFieldsData.html = this.htmlData;

    editTemplateFieldsData.pdfData = { "template_id": this.editTemplateData.id, "fields": editTemplateFieldsData }
    this.editTemplateChange.emit(editTemplateFieldsData);
  }

  nextStepEstamp() {
    this.submitted = true;
    let allFieldsFilled = true;
   
  
    this.templateDataForm.value.fieldDataForms.forEach(field => {
      if (field.validators && field.validators.required) {
        if (!field.value_attribute && allFieldsFilled) {
          this.messageService.add({ severity: 'warn', detail: 'Please fill all the required fields!' });
          allFieldsFilled = false;
          return;
        }
      }
    });
  
    if (allFieldsFilled) {
      this.sendTemplateDetails(); // Call the function only if all fields are filled
    }
  }
  

  backToProductDetails() {
    this.editTemplateData = this.templateDataForm.value;
    this.editTemplateData.page = 'product';
    this.editTemplateChange.emit(this.editTemplateData);
  }


  reviewData(content: any) {
    this.templateData = [];
    this.pdfSource = null;
    this.isLoadingPdf = true;
    this.templateDataValues = JSON.parse(JSON.stringify(this.templateDataForm.value.fieldDataForms));
    this.openReviewTab(content);
  }

  openReviewTab(content: any) {
    this.templateDataValues.forEach((field: any) => {
      if (field.value_attribute === null) {
        field.value_attribute = '  ';
      }
      const data = { key: field.id_attribute, value: field.value_attribute };
      this.templateData.push(data);
    });

    this.modalService.open(content, {
      size: 'lg', ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false,
    }).result.then(() => {}, () => {});

    this.loadPDF({ template_id: this.editTemplateData.id, fields: this.templateData });
  }
  closeModel() {
    this.modalService.dismissAll();

  }
}
